import React, { Component } from 'react';
import { render, unmountComponentAtNode as remove } from 'react-dom';
import PropTypes from 'prop-types';

import decl from '../../helpers/decl';
import isBlankString from '../../helpers/is-blank-string';
import { setCookie, monthTimeout } from '../../helpers/cookie';

import Input from '../input';
import AuthTimer from '../auth/auth-timer';
import Popup from '../popup';

class SettingsPhone extends Component {
  static propTypes = {
    route: PropTypes.shape({
      user: PropTypes.string,
      edit: PropTypes.string,
      login: PropTypes.string,
      verify: PropTypes.string,
    }).isRequired,
  };

  state = {
    code: '',
    loading: false,
    newSms: false,
    phone: '',
    step: 0,
    sms: 0,
  };

  // Шлем запрос
  sendRequest = (url, body, success, error) => {
    const self = this;

    let headers = {
      method: 'POST',
      body: body,
      headers: {},
    };

    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    } else {
      // headers.headers.authorization = getAuth();
    }

    // for (var pair of body.entries()) {
    // 	console.log(pair[0]+ ', ' + pair[1]);
    // }

    this.setState({
      loading: true,
    });

    fetch(url, headers)
      .then(response => response.json())
      .then(json => {
        let sms;

        if (json.status == 'success') {
          sms = json.data.next_sms;
          if (success) success(json.data);
        } else if (json.status == 'error') {
          sms = json.errors.next_sms;
          if (error) error(json.errors);
        }

        if (sms) {
          this.setState({
            loading: false,
            sms,
          });
        } else {
          this.setState({
            loading: false,
          });
        }
      })
      .catch(err => {
        if (error)
          error({
            message: `${err}` || 'Произошла ошибка. Попробуйте еще раз',
          });
      });
  };

  // Таймер тикающий
  timerCallback = () => {
    let { sms } = this.state;
    let newSms;

    if (sms == 1) {
      newSms = true;
    }

    if (sms > 0) {
      sms = sms - 1;
    }

    this.setState({ newSms, sms });
  };

  // Нажали на кнопку
  confirm = (e, again) => {
    e.preventDefault();

    const { route } = this.props;
    const { code, phone, step } = this.state;

    let self = this;
    let cleanPhone = phone
      ? phone.replace(/[/+()_-]*/g, '').replace(/\s/g, '')
      : '';

    // Ошибка
    const error = resp => {
      let message = resp.message;

      if ('next_sms' in resp) {
        message = `${message} ${resp.next_sms} ${decl(resp.next_sms, [
          'секунду',
          'секунды',
          'секунд',
        ])}`;
      }

      $.magnificPopup.open({
        items: {
          src: '#popup',
        },
        removalDelay: 250,
        callbacks: {
          beforeOpen: function() {
            this.st.mainClass = 'mfp-anim';
          },
          open: function() {
            render(
              <Popup
                type="alert"
                status="error"
                title="Ошибка!"
                message={message}
                button="Назад"
              />,
              $('#popup')[0],
            );
          },
          close: function() {
            remove($('#popup')[0]);
          },
        },
      });

      this.setState({
        loading: false,
      });
    };

    // Стадия телефона
    if (!step || again) {
      // Успешно отправлено
      const success = resp => {
        this.setState({
          step: 1,
          newSms: false,
        });
      };

      if (cleanPhone.length == 11) {
        let formData = new FormData();

        setCookie('PHONE', cleanPhone, monthTimeout);
        formData.append('phone', cleanPhone);
        this.sendRequest(route.login, formData, success, error);
      }
    } else {
      if (cleanPhone.length == 11 && !!code) {
        // Успешно отправлено
        const success = () => {
          // document.location.href = '/profile/settings';
          location.reload();
        };

        let formData = new FormData();

        formData.append('phone', cleanPhone);
        formData.append('code', code);
        this.sendRequest(route.verify, formData, success, error);
      }
    }
  };

  render() {
    const { code, loading, newSms, phone, sms, step } = this.state;

    let cleanPhone = phone
      ? phone.replace(/[/+()_-]*/g, '').replace(/\s/g, '')
      : '';
    let btnClasses = ['btn'];

    if (loading) btnClasses.push('btn--loading');
    if (isBlankString(cleanPhone) || cleanPhone.length < 11)
      btnClasses.push('btn--disable');

    let note;

    if (newSms) {
      note = (
        <p className="txt">
          Отправить пароль{' '}
          <a href="#" onClick={e => this.confirm(e, true)}>
            еще раз
          </a>
        </p>
      );
    } else {
      note = (
        <p className="txt">
          Повторно отправить пароль можно
          <AuthTimer
            count={sms}
            words={['секунду', 'секунды', 'секунд']}
            callback={this.timerCallback}
          />
        </p>
      );
    }

    return (
      <div className="page-section__block">
        <div className="page-section__title">
          <h2 className="heading heading--1">Настройки</h2>
        </div>
        <form
          className="inp-group inp-group--2 code-confirm"
          ref={node => (this.form = node)}
        >
          <div className="row">
            <div className="inp-group__case">
              <Input
                error={!step}
                label="Номер телефона"
                name="pnone"
                phone
                value={phone}
                onChange={(val, name) => this.setState({ phone: val })}
              />
            </div>
            <div className="inp-group__case">
              {step ? (
                <div className="wrap wrap--code">
                  <Input
                    label="Код"
                    name="code"
                    value={code}
                    onChange={(val, name) => this.setState({ code: val })}
                  />
                </div>
              ) : null}
              <div className="wrap wrap--btn">
                <button className={btnClasses.join(' ')} onClick={this.confirm}>
                  {step ? 'Подтвердить' : 'Отправить'}
                </button>
              </div>
              {step ? note : null}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default SettingsPhone;
